import { formatPrice } from 'lib/utils'
import { getAjarleePercentageBase, getPaidInsuranceAmount } from '../bookingDetailHelpers'

const VARIANT_STYLES = {
  sky: 'border-sky-200/90 bg-gradient-to-r from-sky-100/95 to-sky-50/80 text-sky-800 ring-1 ring-sky-200/70 shadow-sm',
  emerald: 'border-emerald-200/90 bg-gradient-to-r from-emerald-100/95 to-emerald-50/80 text-emerald-800 ring-1 ring-emerald-200/70 shadow-sm',
}

const AjarleePercentageBaseTag = ({ bookingData, t, variant = 'sky' }) => {
  // Office-collected insurance is not part of the base, so only name insurance when it was actually paid.
  const hasPaidInsurance = getPaidInsuranceAmount(bookingData) > 0
  const labelKey = hasPaidInsurance ? 'booking.orderSummary.ajarleePercentageBaseWithInsurance' : 'booking.orderSummary.ajarleePercentageBase'

  return (
    <div className="w-full pt-1">
      <span className={`inline-flex items-center rounded-full border px-2.5 py-1 text-[11px] font-semibold leading-snug ${VARIANT_STYLES[variant] || VARIANT_STYLES.sky}`}>
        {t(labelKey, {
          amount: formatPrice(getAjarleePercentageBase(bookingData), true),
          currency: t('common.omr'),
        })}
      </span>
    </div>
  )
}

export default AjarleePercentageBaseTag
